export class Util {

  /**
   * Converte uma string ou Date para um objeto Date no fuso local,
   * com hora ajustada para meia-noite (00:00).
   * @param date string no formato ISO "YYYY-MM-DD" ou Date
   * @returns Date correspondente à meia-noite local
   */
  static newDate(date: string | Date): Date {
    let d: Date;

    if (typeof date === 'string') {
      const [year, month, day] = date.split('-').map(Number);
      d = new Date(year, month - 1, day);
    } else if (date instanceof Date) {
      d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    } else {
      throw new Error('Parâmetro inválido para newDate');
    }

    d.setHours(0, 0, 0, 0); // meia-noite
    return d;
  }

  /**
   * Converte uma string ou Date para um objeto Date no fuso local,
   * com hora ajustada para meio-dia (12:00) para evitar problemas de fuso horário.
   * @param date string no formato ISO "YYYY-MM-DD" ou Date
   * @returns Date correspondente ao meio-dia local
   */
  static newDateAtNoon(date: string | Date): Date {
    let d: Date;

    if (typeof date === 'string') {
      const [year, month, day] = date.split('-').map(Number);
      d = new Date(year, month - 1, day);
    } else if (date instanceof Date) {
      d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    } else {
      throw new Error('Parâmetro inválido para newDateAtNoon');
    }

    d.setHours(12, 0, 0, 0); // meio-dia
    return d;
  }

}
